import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ImmigrationProfile } from 'src/app/core/api.gen';
import { isNullOrUndefined } from '../../../../app/core/utils';

@Injectable({
    providedIn: 'root'
})
export class ImmigrationDataPopulationService {
    /**
     * DataPopulationEvents.GpnGuiSearch
     * If this operation is emitted this subject gets new value true
     */
     GpnGuiUpdated = new BehaviorSubject<boolean>(false);
     EmployeeUpdated = new BehaviorSubject<boolean>(false);

    constructor() {

    }

    /**
     * Button needs
     */
    eventsToListenTo(): string[] {
        return [DataPopulationEvents.GpnGuiSearch];
    }
    /**
     * Returns true if the model is valid 
     * for data pull.
     */
    validateModel(subscriptionData: boolean, model: ImmigrationProfile) {
        return subscriptionData &&
            !isNullOrUndefined(model) &&
            ((!isNullOrUndefined(model.employeeSearchTerm)) //|| (model.employeeSearchTerm) //&& !isNullOrUndefined(model.employeeSearchTerm.email)) ||
               || (!isNullOrUndefined(model.gui) && !isNullOrUndefined(model.gpn) && model.gui.trim().length >= 6
                    && model.gpn.trim().length >= 6
                ));
    }

    validateModelCommon(subscriptionData: boolean, model) {
        return subscriptionData &&
            !isNullOrUndefined(model) &&
            ((!isNullOrUndefined(model.employeeSearchTerm)) //&& !isNullOrUndefined(model.employeeSearchTerm.email)) ||
               || (!isNullOrUndefined(model.gui) && !isNullOrUndefined(model.gpn) && model.gui.trim().length >= 6
                    && model.gpn.trim().length >= 6
                ));
    }


}

export enum DataPopulationEvents {
    GpnGuiSearch = 'GpnGuiSearch',
}
